import { h, defineComponent } from 'vue';
import { useCurrentRoute } from '@/ui/routes';
import { maintenanceBanner } from '@/ui/layouts/MaintenanceBanner';

export default defineComponent({
  name: 'SuspendedLayout',
  setup() {
    return function render() {
      const currentRoute = useCurrentRoute();

      return h('div', [
        //might be not in use anymore, maybe remove later
        //h(SuspendedNavbar),
        maintenanceBanner({ display: false }),
        h('router-view', { class: currentRoute.value.meta!.disablePadding ? '' : 'p-8' }),

        // Used by legacy components
        h('portal-target', {
          class: 'legacy',
          attrs: {
            name: 'modals',
            multiple: true,
          },
        }),
      ]);
    };
  },
});
